// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"modalWrap___DUxy9","pointExchangeModal":"pointExchangeModal___1dXxP"};